module.exports = __webpack_public_path__ + "static/media/Inter-Thin.035ae3d8.woff";